import { useEffect } from 'react';
import { useContactStore } from '@lib/store';
import { PageLayout } from '@shared/widgets';
import PhoneIcon from '@assets/images/contact/phone.svg';
import MailIcon from '@assets/images/contact/mail.svg';
import LocationIcon from '@assets/images/contact/location.svg';
import PhoneMobileIcon from '@assets/images/contact/phone_mobile.svg';
import MailMobileIcon from '@assets/images/contact/mail_mobile.svg';
import LocationMobileIcon from '@assets/images/contact/location_mobile.svg';
import bgImg from '@assets/images/contacts_bg.png';
import contactImg from '@assets/images/contact/contact.png';

export const ContactPage = () => {
  const contactStore = useContactStore();

  useEffect(() => {
    contactStore.getContact();
  }, []);

  return (
    <PageLayout>
      <div className='flex h-[750px] max-md:h-auto max-md:flex-col-reverse'>
        <div className='flex grow-1 items-center max-md:block max-md:px-4 max-md:text-center'>
          <div className='flex max-md:block'>
            <div>
              <div className='mb-4 flex items-center max-md:block max-md:text-center'>
                <div className='mr-6 h-full w-[140px] max-md:hidden'>
                  <div className='h-[1px] w-full bg-[#272727]' />
                </div>
                <h1 className='flex h-[107px] items-center font-[Prata] text-[56px] leading-[66px] text-[#272727] max-md:block max-md:h-auto max-md:text-[28px]'>
                  Contact
                </h1>
              </div>
              <div className='ml-[165px] max-md:m-0'>
                <div className='mb-10 flex items-center max-md:mb-12 max-md:flex max-md:flex-col'>
                  <div className='mr-4 flex w-[50px] items-center justify-center max-md:m-0 max-md:mb-4'>
                    <PhoneIcon className='max-md:hidden' />
                    <PhoneMobileIcon className='max-md:inherit hidden' />
                  </div>
                  <div className='flex flex-col font-[ProximaNova] whitespace-pre-wrap'>Call us: {contactStore.data?.phone}</div>
                </div>
                <div className='mb-10 flex items-center max-md:mb-12 max-md:flex max-md:flex-col'>
                  <div className='mr-4 flex w-[50px] items-center justify-center max-md:m-0 max-md:mb-4'>
                    <MailIcon className='max-md:hidden' />
                    <MailMobileIcon className='max-md:inherit hidden' />
                  </div>
                  <div className='flex flex-col font-[ProximaNova] whitespace-pre-wrap'>Email us: {contactStore.data?.email}</div>
                </div>
                <div className='mb-10 flex items-center max-md:mb-12 max-md:flex max-md:flex-col'>
                  <div className='mr-4 flex w-[50px] items-center justify-center max-md:m-0 max-md:mb-4'>
                    <LocationIcon className='max-md:hidden' />
                    <LocationMobileIcon className='max-md:inherit hidden' />
                  </div>
                  <div className='flex flex-col font-[ProximaNova] whitespace-pre-wrap'>{contactStore.data?.address}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='max-md:bg-[length:100%] max-md:pt-[100%] md:!bg-none' style={{ backgroundImage: `url(${bgImg})` }}>
          <img src={contactImg} alt='image' className='max-md:hidden' />
        </div>
      </div>
    </PageLayout>
  );
};
